import { agenticGatewayFieldInstaller } from "./shared.tsx";
import type { AgenticInstaller } from "./types.ts";

type A2aBridgeInstaller = AgenticInstaller["components"]["a2a-bridge"];

export const agenticA2aBridgeInstaller: A2aBridgeInstaller = {
  items: {
    gateway: agenticGatewayFieldInstaller,
  },
};
